import React, { useEffect, useState } from "react";
import i18n, { t } from "i18next";
import CollapsibleNavbar from "../ReservedAreaDashboard/CollapseNavbar";

export default function ErrorPage() {
  const [currentLanguage] = useState<string>(i18n.language);
  const [userId] = useState(localStorage.getItem("userID"));
  const [reservedArea, setReservedArea] = useState(false);
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      setReservedArea(true);
    } else {
      setReservedArea(false);
    }
  }, [userId]);
  return (
    <>
      {reservedArea && <CollapsibleNavbar callFrom="" />}
      <div
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          padding: "10px",
          height: "80vh",
          zIndex: "5000",
          marginLeft: currentLanguage == "it" ? "8%" : "",
        }}
      >
        <span
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: !isSmallScreen ? "35px" : "25px",
          }}
          className="text-black font-bold"
        >
          {t("Something Went Wrong")}
        </span>
        <br />
        <br />
        {currentLanguage == "it" && (
          <span
            className="text-black font-normal "
            style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
          >
            Stiamo risolvendo il problema. Torna a trovarci!
          </span>
        )}
      </div>
    </>
  );
}
